import observeIntersection from './inc/observeIntersection';
import { prefersReducedMotion, revealMotionTargets } from './inc/motionPreference';

/* Author: herrlich media */
document.addEventListener('DOMContentLoaded', () => {
    if (prefersReducedMotion()) {
        revealMotionTargets();
        return;
    }

    if (!document.documentElement.classList.contains('motion-enhanced')) {
        document.documentElement.classList.add('motion-enhanced');
    }

    observeIntersection('.fadeIn', (isIntersecting, e) => {
        if (isIntersecting) {
            $(e.target).not('.vis').addClass('vis');
        }
    }, true);

    observeIntersection('.fadeInRow', (isIntersecting, e) => {
        if (isIntersecting) {
            $(e.target)
                .find('> div, > li, > p, > span, > h1, > h2, > a, > .topline')
                .not('.vis')
                .each((i, el) => {
                    setTimeout(() => {
                        $(el).addClass('vis');
                    }, 150 * i);
                });
        }
    }, true);
});
